import { createContext, useState } from "react";

export const PVContext = createContext();

export const PVProvider = ({ children }) => {
  const [pvSearchTerm, setPvSearchTerm] = useState("");
  const [pvFilters, setPvFilters] = useState({
    status: "",
    name: "",
    mobile: "",
    dob: "",
    startDate: "",
    endDate: "",
    createdAt: "",
    updatedAt: "",
    verificationType: "",
  });

  const [ContextCurrentPage, contextSetCurrentPage] = useState(1);
  const [ContextTotalPages, contextSetTotalPages] = useState(0);
  const [Contextlimit] = useState(5);
  const [ContextReload, ContextSetReload] = useState(false);
  const [verificationType, setVerificationType] = useState("BGPROFILE");

  return (
    <PVContext.Provider
      value={{
        pvSearchTerm,
        setPvSearchTerm,
        pvFilters,
        setPvFilters,
        ContextCurrentPage,
        contextSetCurrentPage,
        ContextTotalPages,
        contextSetTotalPages,
        Contextlimit,
        ContextReload,
        ContextSetReload,
        verificationType,
        setVerificationType,
      }}
    >
      {children}
    </PVContext.Provider>
  );
};
